import Fade from '@mui/material/Fade';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { viewProductSweetGoods } from '../atoms/Header-Atoms'
import { useRecoilValue } from 'recoil';
import SourdoughFruitScone from '../images/sourdough-fruit-scones.png';
import BananaBread from '../images/banana-bread.png';
import MoravianSugarCake from '../images/moravian-cake.png';
import CinnamonStarBread from '../images/cinnamon-star-bread.png';
import CinnamonBuns from '../images/cinnamon-buns.png';
import AppleBread from '../images/apple-bread.png';
import PumpkinBread from '../images/pumpkin-bread.png';
import FruitBuckle from '../images/fruit-buckle.png';
import MonsterBrownies from '../images/monster-brownies.png';
import AppleSpeltCake from '../images/apple-spelt-cake.png';
import LemonBlueberryBread from '../images/lemon-blueberry-bread.png';
import PetiteChocolateCake from '../images/petite-chocolate-cake.png';

function ProductSweetGoods() {
    const enabled = useRecoilValue(viewProductSweetGoods);

    return (
        <Fade in={enabled} timeout={{ enter: 400, exit: 400 }}>
            <div id="section-3" className="contentModule">
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={LemonBlueberryBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Lemon Blueberry Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Bursting with fresh blueberries and bright citrus flavor, our Lemon & Blueberry Sweetbread is a delightful balance of sweet and tangy. Made from scratch with real lemons and plump, juicy blueberries, each loaf is soft, moist, and infused with natural flavor. Finished with a sweet lemon glaze that adds a wonderful finish, this sweetbread is perfect for breakfast, brunch, or an elegant afternoon treat. Handcrafted in small batches to ensure quality and freshness in every slice.</p>
                                        <p>Ingredients: Blueberry, Flour, Sugar, Sunflower Oil, Eggs, Olive Oil, Baking Powder, Lemon, Sour Cream and Salt.</p>
                                        <p>Price: $6 USD (each, minimum 2 per order)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={CinnamonBuns}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Cinnamon Bun
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>A refined twist on a classic favorite. Our Braided & Glazed Cinnamon Buns are hand-braided with soft, enriched dough layered with a rich blend of brown sugar and warm cinnamon. Baked to golden perfection, each bun is finished with a delicate, glossy glaze that adds just the right amount of sweetness. Every bite is tender, flavorful, and irresistibly satisfying. Perfect for breakfast, brunch, or a sweet afternoon indulgence.</p>
                                        <p>Ingredients: Flour, Milk, Butter, Sugar, Eggs, Brown Sugar, Cinnamon, Yeast, Maple Syrup and Salt.</p>
                                        <p>Price: $4 USD (each - minimum 4 per order)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={AppleSpeltCake}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Apple Spelt Cake
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Indulge in the warm, nutty flavors of our lightly spiced individual cakes made with spelt flour, perfect for capturing that autumn spirit. They offer just the right amount of sweetness, making them an ideal choice for breakfast with a great cup of coffee, a mid-afternoon boost or even a lovely dessert paired with some chamomile. Our Apple Cakes are brimming with walnuts, raisins, and honey crisp apples, harmonizing beautifully to create a symphony of flavors in this delightful treat.</p>
                                        <p>Ingredients: Apple, Raisins, Spelt Flour, Flour, Walnuts, Brown Sugar, Sugar, Sunflower Oil, Eggs, Milk, Olive Oil, Baking Soda, Maple Syrup, Cinnamon and Salt.</p>
                                        <p>Price: $4 USD (each - minimum 4 per order)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={PetiteChocolateCake}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Petite Chocolate Cake
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Sink your fork into a chocolate lover’s dream — a deeply rich, ultra-moist chocolate cake that melts in your mouth with every bite. Crafted with premium cocoa and baked to perfection, this cake is as soft and tender as it is bold and flavorful.</p>
                                        <p>Topped with a silky, cloud-like ermine frosting — a classic cooked flour buttercream that’s luxuriously smooth without being too sweet — this cake delivers old-fashioned charm with a gourmet twist.</p>
                                        <p>Ingredients: Sugar, Flour, Milk, Sunflower / Olive Oil, Unsweetened Cocoa, Eggs, Coffee, Baking Soda, Baking Powder, Brandy and Salt.</p>
                                        <p>Price: $5 USD (each - minimum 4 per order)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={BananaBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Banana Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Beautifully ripened bananas give this wonderful banana bread the perfect amount of sweetness you want in a banana bread. Soft and delicious, with a moist interior and a rich banana flavor. These mini loaves will be a hit at your breakfast or brunch table.</p>
                                        <p>Ingredients: Flour, Brown Sugar, Butter, Banana, Egg, Baking Soda and Salt.</p>
                                        <p>Price: $5 USD (each, minimum 2 per order)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={MoravianSugarCake}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Moravian Sugar Cake
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Our Moravian Sugar Cakes are crafted from soft, yeast-raised dough, each cake is hand-pressed to create deep pockets that hold rich melted butter, brown sugar, and a touch of cinnamon. As it bakes, the topping caramelizes into a golden, buttery crust while the interior stays tender and fluffy.</p>
                                        <p>These sweet, indulgent cakes are perfect for breakfast, brunch, or as a comforting treat any time of day. Warm them slightly to release their irresistible aroma and enjoy a bite of nostalgic, North Carolina tradition.</p>
                                        <p>Ingredients: Flour, Milk, Sugar, Brown Sugar, Butter, Potatoes, Eggs, Sunflower and Olive Oil, Maple Syrup, Cinnamon, Malt Barley, Yeast and Salt.</p>
                                        <p>Price: $6 USD (each, minimum 2 per order)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={CinnamonStarBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Cinnamon Star Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Indulge in our delightful Cinnamon Star Bread, a stunning pull-apart sweet bread that makes for an eye-catching centerpiece at any gathering. Each layer is generously filled with a delicious cinnamon-sugar blend, reminiscent of a traditional cinnamon roll. Baked to a perfect golden brown on the outside, it boasts a soft and fluffy interior and then glazed with a light icing. If you happen to have any leftovers the next day, simply warm a piece in the microwave for 20 seconds and enjoy it alongside your favorite coffee for a truly fantastic breakfast experience.</p>
                                        <p>Ingredients: Flour, Whole Milk, Butter, Eggs, Spring Water, Cinnamon, Yeast, Malt Barley and Salt.</p>
                                        <p>Price: $15 USD (each)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={SourdoughFruitScone}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Sourdough Cranberry Orange Scones
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>A tender, buttery scone made with our naturally fermented sourdough starter, folded with orange-soaked cranberries and an abundant amount of fresh orange zest. Built for height and flakiness, each scone bakes up golden with delicate layers, bright citrus aroma, and balanced sweetness. Finished with a light crunch of turbinado sugar, these scones are vibrant and fragrant.</p>
                                        <p>Ingredients: Flour, Butter, Sugar, Milk, Dried Cranberries, Oranges, Egg, Turbinado Sugar, Baking Powder and Salt. </p>
                                        <p>Price: $3 USD (each - minimum 4 per order)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={FruitBuckle}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Fruit Buckle
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>The Fruit Buckle has an amazing combination of flavors and textures. With a rustic appearance in a tulip cup, you'll be greeted with a soft and moist crumb, mellow sweetness, and seasonal fruit. Lastly, the Fruit Buckles are topped with a delightful streusel that ties everything together.</p>
                                        <p>Ingredients: Flour, Milk, Fruit (specific to order), Sugar, Butter, Brown Sugar, Egg, Cornstarch, Baking Powder, Maple Syrup, Salt and Lemon Juice.</p>
                                        <p>Price: $4 USD (each - minimum 4 per order)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={AppleBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Apple Cinnamon Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Our mildly sweet Apple Cinnamon Bread boasts a moist texture and a delicate crumb, delighting the palate with the comforting aromas of cinnamon and nutmeg. Brown sugar folded directly into the batter adds a rich, caramel depth throughout, making each bite soft, flavorful, and perfectly balanced—an ideal indulgence for a crisp autumn day.</p>
                                        <p>Ingredients: Applesauce, Flour, White Wheat Flour, Eggs, Sugar, Brown Sugar, Sunflower Oil, Whole Milk, Olive Oil, Baking Soda, Cinnamon, Baking Powder, Salt and Nutmeg.</p>
                                        <p>Price: $5 USD (each - minimum 2 per order)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={MonsterBrownies}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Brownie Minis
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>These brownies are everything you could wish for: a moist, fudgy core, a beautifully crackled top, and chewy edges that enhance each mouthful. Decadent and rich, they are perfect for satisfying your chocolate urges. Made with high quality dark and semi-sweet chocolate, these small delights are bursting with flavor.</p>
                                        <p>Ingredients: Sugar, Flour, Dark Chocolate, Sunflower/Olive Oil Blend, Eggs, Cocoa Powder, Spring Water, Salt and Brandy.</p>
                                        <p>Price: $5 USD (each 4 count - minimum 2 packs per order)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={PumpkinBread}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Pumpkin Bread
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>This delectable sweet bread, infused with pumpkin flavor and warm autumn spices, offers a delightful treat. The mini loaf boasts a uniformly fine and delicate crumb, yielding an exceptionally soft and moist texture. It is perfect for enjoying solo or alongside a soothing cup of tea or coffee.</p>
                                        <p>Ingredients: Pure Pumpkin Puree, Flour, Sugar, Brown Sugar, Butter, Eggs, Canola Oil, Baking Soda, Cinnamon, Cloves, Nutmeg and Salt.</p>
                                        <p>Price: $5 USD (each - minimum 2 per order)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        </Fade>      
    );
}

export default ProductSweetGoods;